var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"owl-carousel owl-theme"},_vm._l((_vm.banners),function(banner,i){return _c('div',{key:i,staticClass:"adapter-item items"},[_c('b-img',{attrs:{"fluid":"","src":banner.src,"alt":banner.alt}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }